import React from 'react'
import styled from 'styled-components'
import { useLocation } from 'react-router-dom'
import LogoComponent from './LogoComponent'

const HeaderRow = styled.div`
  position: fixed;
  left: 1.5rem;
  top: 1.5rem;
  display: flex;
  align-items: center;
  gap: 1.2rem;
  z-index: 10;

  @media (max-width: 600px) {
    position: absolute;
  }
`

const Title = styled.h1`
  font-size: clamp(1.1rem, 3vw, 1.6rem);
  color: ${(props) => props.theme.black};
  margin: 0;

  span {
    color: ${(props) => props.theme[props.$accent]};
    ${(props) => props.$stroke && `text-shadow: 1.5px 1.5px 0 ${props.theme.black};`}
  }
`

// Which title (if any) shows next to the logo, per route.
const PAGE_TITLES = {
  '/work': { text: 'My', highlight: 'Projects', accent: 'blossom' },
  '/skills': { text: 'My', highlight: 'Skills', accent: 'bubbles', stroke: true },
}

// Fixed, global logo + page title row. Rendered once in App.js so the title
// stays pinned next to the logo and swaps dynamically as the route changes.
const PageHeader = () => {
  const location = useLocation()
  const page = PAGE_TITLES[location.pathname]

  return (
    <HeaderRow>
      <LogoComponent inline />
      {page && (
        <Title $accent={page.accent} $stroke={page.stroke}>
          {page.text} <span>{page.highlight}</span>
        </Title>
      )}
    </HeaderRow>
  )
}

export default PageHeader
